import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";


import bootcamp from "../IMG/bootcamp.gif";
import ask from "../IMG/ask.jpg";
import aldaraz from "../IMG/aldaraz.gif";
import Plantscrape from "../IMG/Plantscrape.gif";
import wds from "../IMG/WDS.gif";
import makerble from "../IMG/chat.gif";
import portfolio from "../IMG/portfolio.gif";
import ewent from "../IMG/ewent.gif";
import foodies from "../IMG/Foodie.PNG";
import ranter from "../IMG/Ranter.png";
import houseofmarktechs from "../IMG/houseofmarktechs.PNG"
import inwenttree from "../IMG/inwenttree.PNG"
import shorts from "../IMG/shorts.gif"
import docify from "../IMG/docify.gif"
import map from "../IMG/map.gif"
import tokenly from "../IMG/tokenly.gif"

const ProjectsCarousel = () => {
  const projects = [
    {
      id: 1,
      name: "Bootcamp - Group-Based Chatting Application",
      description: "Mobile App Development | Dart, Flutter, Firebase",
      image: bootcamp,
    },
    {
      id: 2,
      name: "ASK GPT - AI Chatbot Application",
      description: "Mobile App Development | Java, OpenAI API",
      image: ask,
    },
    {
      id: 3,
      name: "CCTV Violence Detection System",
      description: "Software Development | Python, Django",
      image: wds,
    },
    {
      id: 4,
      name: "Aldaraz.com - Professional Service Website",
      description: "Web Development | HTML5, CSS3, JavaScript",
      image: aldaraz,
    },
    {
      id: 5,
      name: "PlantScrape",
      description: "UI/UX | Figma",
      image: Plantscrape,
    },
    {
      id: 6,
      name: "Makerble",
      description: "UI/UX | Figma",
      image: makerble,
    },
    {
      id: 7,
      name: "My Portfolio",
      description:
        "Web Development | React.js, Node.js, Tailwind CSS, Visual Studio Code",
      image: portfolio,
    },
    {
      id: 8,
      name: "E-went - Event Management Platform",
      description:
        "Web Development | React.js, Express.js, Tailwind CSS, Visual Studio Code",
      image: ewent,
    },
    {
      id: 9,
      name: "Foodiees",
      description:
        "Web Development | React.js, HTML5, CSS3, Visual Studio Code",
      image: foodies,
    },
    {
      id: 10,
      name: "House Of Marktechs",
      description:
        "Web Development | React.js, Tailwind CSS, JSONPlaceholder API, Lazy loading, Vite",
      image: houseofmarktechs,
    },
    {
      id: 11,
      name: "In-went-tree",
      description:
        "Web Development | React (Vite), Tailwind CSS, React Icons, VS Code",
      image: inwenttree,
    },
    {
      id: 12,
      name: "Ranter - Anonymous Rant System",
      description:
        "Web Development | HTML, CSS, PHP, MYSQL, XAMPP, Visual Studio Code",
      image: ranter,
    },
    {
      id: 13,
      name: "Shorts - URL Shortner",
      description:
        "Web Development | React.js, Express.js, MongoDB, Tailwind CSS, Visual Studio Code",
      image: shorts,
    },
    {
      id: 14,
      name: "Docify – Smart Document Workspace with AI",
      description:
        "Web Development | React.js, Express.js, MongoDB, Tailwind CSS, Visual Studio Code",
      image: docify,
    },
    {
      id: 15,
      name: "USSD - Map",
      description:
        "Software Development | Java, Spring Boot, Google Map API, Africa’s Talking, MySQL, Ngrok",
      image: map,
    },
    {
      id: 16,
      name: "Tokenly - Auth as a service",
      description:
        "Software Development | Spring Boot, Java, MySQL, React.js, Redis",
      image: tokenly,
    },
  ];

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <div className="bg-white shadow-md rounded-md p-6">
      <h2 className="text-2xl font-semibold mb-4">Projects</h2>
      <Carousel
        responsive={responsive}
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={2000}
        arrows={false}
      >
        {projects.map((project) => (
          <div key={project.id} className="text-center p-4">

            <img
              src={project.image}
              alt={project.name}
              className="h-40 rounded-md mb-2 mx-auto block"
            />


            <p className="text-lg font-medium">{project.name}</p>
            <p className="text-sm text-gray-500">{project.description}</p>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default ProjectsCarousel;
